module.exports = __webpack_public_path__ + "img/showfuture.0baff178.png";